export default function RestaurantHome() {
  return <div></div>;
}
